import React from 'react';
import CollectionDatasetAssignRow from './CollectionDatasetAssignRow';

const CollectionDatasetsAssignTableRows = ({
  category,
  code,
  items,
  entity,
  onChange,
  removeDataset,
}) => (
  items.map((item) => (
    <CollectionDatasetAssignRow
      key={`collection_dataset_table_row_${item.code}`}
      dataset={item}
      entity={entity}
      onChange={onChange}
      removeDataset={(datasetCode) => removeDataset(category, code, datasetCode)}
    />
  ))
);
export default CollectionDatasetsAssignTableRows;
